<script>
import { insTypeName, insTypeOrders } from 'base/config'
import Insurance from 'base/model/insurance'

export default {
  name: 'LiabilityTable',
  filters: {
    insTypeFilter(value) {
      if (value <= 0 || value > 9) return ''
      return insTypeName[value - 1] || ''
    },
  },
  props: {
    init: {
      type: Boolean,
      default: false,
    },
    members: {
      type: Array,
      default() {
        return []
      },
    },
    resultData: {
      type: Object,
      default() {
        return {}
      },
    },
    showType: {
      type: Number,
      default: 0,
    },
    showComplete: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    membersInsType() {
      const { members } = this
      const result = members.slice()
      result.forEach((item) => {
        const insTypeList = []
        if (!Array.isArray(item.insurances)) return
        // const categorySort = item.insurances[0].categorySort
        // const insTypeOrder = insTypeOrders[categorySort]
        let libLen = 0
        item.insurances.forEach((ins, index) => {
          const outLiabilities = ins.liabilities
          if (!Array.isArray(outLiabilities)) return

          outLiabilities.forEach((lib, libIdx) => {
            const insLiabilities = lib.insuranceLiabilities
            if (!Array.isArray(insLiabilities)) return
            const productId = lib.productId
            insLiabilities.forEach((insLib, insLibIdx) => {
              const insuranceId = insLib.insuranceId
              const insuranceName = insLib.insuranceName
              const liabilities = insLib.liabilities
              if (!Array.isArray(liabilities)) return
              liabilities.forEach((lb, lbIdx) => {
                const categoryId = lb.categoryId || 9
                // const insTypeIndex = insTypeOrder.indexOf(categoryId)

                if (
                  insTypeList[categoryId] &&
                  insTypeList[categoryId][insuranceId]
                ) {
                  insTypeList[categoryId][insuranceId].liabilities.push(lb)
                } else if (insTypeList[categoryId]) {
                  insTypeList[categoryId][insuranceId] = {
                    insuranceName,
                    productId,
                    calIndex: index,
                    liabilities: [lb],
                  }
                  libLen++
                } else {
                  insTypeList[categoryId] = {
                    [insuranceId]: {
                      insuranceName,
                      productId,
                      calIndex: index,
                      liabilities: [lb],
                    },
                  }
                  libLen++
                }
              })
            })
          })
        })
        item.instypeList = insTypeList
        item.libLen = libLen
        const keysList = Object.keys(insTypeList)
        item.instypeListLen = keysList.length
        item.nameCellIndex = keysList[0]
        console.log(result)
      })

      return result
    },
  },
  methods: {
    _format(prodId, template = '', data = {}) {
      let self = this
      let keys = Object.keys(data)
      let dataList
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      if (!template) template = ''
      const stuff = this._stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList

      // -- end 12.15 --

      // 这里使用反引号来构建模板引擎
      // let Fn = new Function
      let g = new Function(
        keys.join(','),
        'return this._formatFnCenter `' + template + '`;'
      )
      return g.apply(self, dataList)
    },
    _formatFnCenter(templateData) {
      var resultTemp = templateData[0]

      // console.log(['arg', templateData]);

      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i])

        // 金额显示整万
        if (templateData[i].match(/元/)) {
          arg = String(this._formatTenThousand(arg))
        }

        // 金额显示保留2位小数
        // fix 纯数字才进入逻辑
        if (!isNaN(arg) && arg.split('.')[1]) {
          arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
        }
        resultTemp += arg
        resultTemp += templateData[i]
      }
      return resultTemp
    },
    _formatTenThousand(number) {
      var regExp = /^[+-]?[1-9]?[0-9]*\.[0-9]*$/,
        result = 0
      if (!(typeof parseFloat(number) === 'number')) return number
      number = parseFloat(number)
      if (number % 10000 === 0 && number >= 10000) {
        number = number / 10000
        result = (regExp.test(number) ? number.toFixed(2) : number) + '万'
      } else {
        result = regExp.test(number) ? number.toFixed(2) : number
      }
      return result
    },
    _createLiabilities(prodId, liab) {
      let ret = []
      let { data, __c, _format, _formatLow, _formatASCII } = this
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      targetAry.forEach((lib) => {
        lib &&
          showKeys.forEach((sk) => {
            let libItem = lib[sk]
            if (libItem) {
              let resultHTML
              try {
                resultHTML = _format(prodId, libItem, data)
              } catch (er) {
                resultHTML = _formatLow(prodId, libItem, data)
              }
              resultHTML = _formatASCII(resultHTML)

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length &&
                  preHandleKeys.forEach((pre, index) => {
                    if (pre.key === sk) {
                      resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                    }
                  })

                // console.log(['resultHTML', resultHTML]);
                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML,
                  },
                })
                ret.push(libVNode)
              }
            }
          })
      })

      return ret
    },
    _stuffingTemplateIns(template, keys, dataList) {
      // console.log('sf', template, keys, dataList)
      let tpKeys = template.match(/i\d+/g)
      tpKeys = [...new Set(tpKeys)]
      let iKeys = keys.filter((k) => {
        return k.match(/i\d+/)
      })

      let notKeys = tpKeys.filter((d) => {
        return iKeys.indexOf(d) === -1
      })

      notKeys.forEach((nk) => {
        keys.push(nk)
        dataList.push(new Insurance())
      })

      return {
        keys,
        dataList,
      }
    },
    getMemberInsLen(list) {
      let len = 0
      if (!list || !Array.isArray(list)) return
      list.forEach((pb) => {
        if (!pb.liabilities) return
        pb.liabilities.forEach((ins) => {
          const iLab = ins.insuranceLiabilities
          const iLen = (iLab && iLab.length) || 0
          len += iLen
        })
      })
      return len
    },
    getMemberProLen(list) {
      let len = 0
      if (!list || !Array.isArray(list)) return
      list.forEach((ins) => {
        const iLab = ins.insuranceLiabilities
        len += iLab && iLab.length
      })
      return len
    },
    getInsCategoryName(ins) {
      if (!ins || !Array.isArray(ins)) return ''
      const categorySort = 'normal' // ins.categorySort ||
      const insTypeIndex = insTypeOrders[categorySort]
      let category = []
      ins.forEach((item) => {
        const index = insTypeIndex.indexOf(item.categoryId)
        if (category[index]) return
        category[index] = item.categoryName
      })

      return category.filter((item) => item).join('<br>')
    },
  },
}
</script>

<template>
  <div>
    <div v-if="showType === 0" class="pc-table-wrap liability-table">
      <table
        v-if="init && members && members.length"
        class="pc-table responsibility-table"
      >
        <thead>
          <tr>
            <th>被保人</th>
            <th>保障计划</th>
            <th>险种</th>
            <th>保障概要</th>
            <th>保障责任</th>
          </tr>
        </thead>
        <tbody v-for="(tb, ti) in members" :key="Math.random()">
          <template v-for="(pb, ib) in resultData[tb.cid].lib.insurances">
            <template v-for="(pd, ip) in pb.liabilities">
              <tr
                v-for="(ins, ii) in pd.insuranceLiabilities"
                :data-m="ti"
                :data-r="ib"
                :data-l="ip"
                :data-i="ii"
              >
                <template v-if="ib === 0 && ip === 0 && ii === 0">
                  <td
                    :rowspan="
                      getMemberInsLen(resultData[tb.cid].lib.insurances)
                    "
                  >
                    <div class="table-user">
                      <div class="head">
                        <img :src="tb.relationImg" :alt="tb.name">
                      </div>
                      <p class="info">
                        {{ tb.name }}
                      </p>
                    </div>
                  </td>
                </template>
                <!-- <template v-if="ip === 0 && ii === 0">
                    <td :rowspan="getMemberProLen(pb.liabilities)">{{ pb.insuranceName }}</td>
                  </template> -->
                <template v-if="ii === 0">
                  <td :rowspan="pd.insuranceLiabilities.length">
                    {{
                      pb.resultData.productGroupList[0].prodOrderList[ip]
                        .titleName
                    }}
                  </td>
                </template>
                <td>{{ ins.insuranceName }}</td>
                <td v-html="getInsCategoryName(ins.liabilities)" />
                <td>
                  <div class="ins">
                    <div v-for="lb in ins.liabilities">
                      <!-- <div class="headline"
                        v-if="lb.headline">{{ lb.headline }}</div> -->
                      <div
                        v-if="lb.description1"
                        class="description1"
                        v-html="
                          _format(
                            pd.productId,
                            lb.description1,
                            resultData[tb.cid].calAry[ib]
                          )
                        "
                      />
                      <div
                        class="description2"
                        v-html="
                          _format(
                            pd.productId,
                            lb.description2,
                            resultData[tb.cid].calAry[ib]
                          )
                        "
                      />
                      <div
                        v-if="showComplete"
                        class="comment"
                        v-html="
                          _format(
                            pd.productId,
                            lb.comment,
                            resultData[tb.cid].calAry[ib]
                          )
                        "
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          <tr v-if="resultData[tb.cid].lib.insurances" class="remark">
            <td>备注</td>
            <td colspan="4" />
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showType === 1" class="pc-table-wrap insuranceType-table">
      <table
        v-if="init && members && members.length"
        class="pc-table instype-table"
      >
        <thead>
          <tr>
            <th>被保人</th>
            <th>保障概要</th>
            <th>险种</th>
            <th>保障责任</th>
          </tr>
        </thead>
        <tbody v-for="(mb, mi) in membersInsType" :key="Math.random()">
          <template v-for="(instype, ti) in mb.instypeList">
            <template v-for="(insKey, productId, ki) in instype">
              <tr
                :data-mi="mi"
                :data-ti="ti"
                :data-ki="ki"
                :data-pi="productId"
              >
                <template v-if="ki === 0">
                  <template v-if="ti == mb.nameCellIndex">
                    <td :rowspan="mb.libLen">
                      <div class="table-user">
                        <div class="head">
                          <img :src="mb.relationImg" :alt="mb.name">
                        </div>
                        <p class="info">
                          {{ mb.name }}
                        </p>
                      </div>
                    </td>
                  </template>
                  <td :rowspan="Object.keys(instype).length">
                    {{ ti | insTypeFilter }}
                  </td>
                </template>
                <td>{{ insKey.insuranceName }}</td>
                <td>
                  <div class="ins">
                    <div v-for="lb in insKey.liabilities">
                      <div v-if="lb.headline" class="headline">
                        {{ lb.headline }}
                      </div>
                      <div
                        v-if="lb.description1"
                        class="description1"
                        v-html="
                          _format(
                            insKey.productId,
                            lb.description1,
                            resultData[mb.cid].calAry[insKey.calIndex]
                          )
                        "
                      />
                      <div
                        class="description2"
                        v-html="
                          _format(
                            insKey.productId,
                            lb.description2,
                            resultData[mb.cid].calAry[insKey.calIndex]
                          )
                        "
                      />
                      <div
                        v-if="showComplete"
                        class="comment"
                        v-html="
                          _format(
                            insKey.productId,
                            lb.comment,
                            resultData[mb.cid].calAry[insKey.calIndex]
                          )
                        "
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          <!-- <tr>
            <td :rowspan="instype.instypeListLen">
              <div class="user">
                <div class="head">
                  <img :src="instype.relationImg"
                    :alt="instype.name">
                </div>
                <div class="info">{{ instype.name }}</div>
              </div>
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="postcss">
@import 'variable.css';

.liability-table,
.instype-table {
  .description1 {
    position: relative;
    margin-bottom: 5px;
    margin-top: 4px;
    line-height: 21px;
    font-size: 15px;
    text-align: justify;
    span {
      position: relative;
      top: 1px;
      font-size: 18px;
      font-weight: 500;
      margin: 0 3px;
      line-height: 1;
      color: #ed9e14;
    }
    &:before {
      content: '';
      position: absolute;
      left: -10px;
      top: 8px;
      border: 3px solid #ed9e14;
      border-radius: 50%;
      vertical-align: middle;
    }
  }

  .description2 {
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 20px;
    color: var(--patch-color-text);
  }

  .waitingDuration,
  .comment {
    font-size: 14px;
    margin-bottom: 15px;
    line-height: 20px;
    color: var(--patch-color-text);
  }

  .comment {
    /*display: none;*/
    margin-top: -2px;
    text-align: justify;
  }

  .headline {
    font-size: 17px;
    margin-bottom: 5px;
    font-weight: bold;
  }
}

.liability-table {
  .ins {
    padding-left: 25px;
  }

  .responsibility-table {
    margin-bottom: 30px;
    thead {
      th {
        background-color: #ffb23e;
        color: #fff;
      }
    }
    th {
      &:nth-child(1) {
        width: 12%;
      }
      &:nth-child(2) {
        width: 14%;
      }
      &:nth-child(3) {
        width: 18%;
      }
      &:nth-child(4) {
        width: 10%;
      }
    }
    .remark {
      background-color: #fdfdfd;
      td:first-child {
        color: #999;
        text-align: center;
      }
    }
  }
}

.instype-table {
  th {
    &:nth-child(1) {
      width: 12%;
    }
    &:nth-child(2) {
      width: 14%;
    }
  }
}

.table-user {
  display: flex;
  .head {
    overflow: hidden;
    width: 36px;
    height: 36px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .info {
    padding-top: 10px;
    padding-left: 6px;
  }
}
</style>